

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import { useSelector } from "react-redux";

import bonusPDF from "../../../../assets/bonus.pdf";




// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);
    const userInfo = useSelector(state => state.userInfo);


    const { setLoading, successToast, errorToast } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const handleChange = (event, value) => {
        setPage(value);
        getDataList(value)
    };

    const [dataList, setDataList] = useState(null)

    async function getDataList(page) {
        setLoading(true)
        try {
            let res = await UserApi.bidRegisterSearch({ page: page, type: "record" })
            console.log(res.data.data)
            setDataList(res.data.data)
            setTotalPage(res.data.total == 0 ? 1 : Math.ceil(res.data.total / 10))

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        // getDataList(1)
    }, []);

    return <div>
        <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
{/*
            <div className="w-full flex justify-between items-center mb06">
                <div className="text-lg font-bold ">{t('memberCenterType.userGrade')}</div>
                <a href={bonusPDF} target="_blank" className="btn1 !bg-red1 !rounded-md text-center">獎金制度說明</a>
            </div>
*/}
            {userInfo &&
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                    <div>
                        <p className="text-sm font-bold mb-2">會員編號</p>
                        <div className="input w-full" >
                            {userInfo.systemId}
                        </div>
                    </div>
                    <div>
                        <p className="text-sm font-bold mb-2">會員身份</p>
                        <div className="input w-full" >
                            {userInfo.identity && t(`grade.${userInfo.identity.name}`)}
                        </div>
                    </div>
                    {
                        userInfo.identity.id != 1 && <>
                            <div className="">
                                <p className="text-sm font-bold mb-2">會員起始日</p>
                                <div className="input w-full" >
                                    {userInfo.identityStartDate}
                                </div>
                            </div>
                            <div >
                                <p className="text-sm font-bold mb-2">會員截止日（90天）</p>
                                <div className="input w-full" >
                                    {userInfo.identityExpirationDate}
                                </div>
                            </div>
                        </>
                    }
                    {
                        (userInfo.identity.id == 2 || userInfo.identity.id == 4 || userInfo.identity.id == 6) &&
                        <div>
                            <p className="text-sm font-bold mb-2">續約金額</p>
                            <div className="input w-full" >
                                ${separatorNumber(userInfo.renewalPrice)}
                            </div>
                        </div>
                    }
                    <div>
                        <p className="text-sm font-bold mb-2">當期個人總累積消費金額</p>
                        <div className="input w-full" >
                            ${separatorNumber(userInfo.totalSpentAmount)}
                        </div>
                    </div>
                    {
                        userInfo.identity.id >= 4 &&
                        <div>
                            <p className="text-sm font-bold mb-2">下線當期累積消費金額</p>
                            <div className="input w-full" >
                                ${separatorNumber(userInfo.totalMemberSpentAmount)}
                            </div>
                        </div>
                    }




                </div>
            }
        </div>
        <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
            <div className="text-lg font-bold mb-4">{t('memberCenterType.vouchers')}</div>

            <div className="grid grid-cols-1 gap-7">
                <div>
                    <p className="text-sm font-bold mb-2">會員可使用總購物金</p>
                    <div className="input w-full" >
                        ${userInfo && separatorNumber(userInfo.shoppingPoints)}
                    </div>
                </div>
                {
                    userInfo && userInfo.shoppingPoints != 0 &&

                    <div>
                        <p className="text-sm font-bold mb-2">購物金到期日期</p>
                        <div className="input w-full" >
                            {userInfo && userInfo.shoppingPointsExpirationDate}
                        </div>
                    </div>
                }

            </div>


        </div>

    </div>

}

export default Home